/**
 * The authenticated page: which korps you are entering for, the ploegen already entered, and
 * the two doors a signed-in persoon can find closed.
 */
export const ploegen = {
  page: {
    title: "Mijn ploegen",
    seizoen: "Seizoen {{naam}}",
    geenSeizoen: "Er staat nog geen seizoen klaar.",
    /* Left of the ploegen rather than above them since the korpsenlijst became a pane. */
    kiesKorps: "Kies links het korps waarvoor je inschrijft.",
  },

  korpsen: {
    label: "Korpsen",
    korps: "Korps",
    plaats: "Plaats",
    zoek: "Zoek een korps",
    leeg: "Je mag voor geen enkel korps inschrijven.",
    /* The phone's way out of the detail pane, where the list is not on screen beside it. */
    terug: "Terug naar de korpsen",
  },

  /**
   * Names the remedy rather than the mailbox: since #33 this is the ordinary outcome for every
   * jeugdleider who is not their korps's contact.
   */
  geenKorps: {
    title: "Je mag nog niet voor een korps inschrijven",
    portaal:
      "Je bent ingelogd. In het JBNL Portaal staat nog niet dat je voor je korps mag handelen. Vraag de beheerder van je korps om je daar de rol <strong>Beheerder</strong> te geven. Daarna kun je hier inschrijven.",
    regiocontactBefore:
      "Ben je regiocontact? Vraag dan dezelfde rol aan bij je veiligheidsregio. Lukt dat niet? Mail ",
    regiocontactAfter: ".",
    wedstrijdleider:
      "Ben je wedstrijdleider of bestuurslid van JBNL? Log dan in op de backoffice.",
  },
} as const;
